import { create } from 'zustand';
import {
  BuildPalletOperation,
  RpaasRtvWmsBuildCartonObject,
  RpaasRtvWmsBuildPalletObject,
} from '../types';
import { buildPallet as apiBuildPallet } from 'services/api/palletBuild';
import { useAuthStore } from './authStore';
import { PALLET_BUILD_OPERATION_TYPES } from 'utils/constants';

interface PalletBuildState {
  cartonId: string | null;
  carton: RpaasRtvWmsBuildCartonObject | null;
  pallet_id: string | null;
  pallet: RpaasRtvWmsBuildPalletObject | null;
  setCartonId: (id: string | null) => void;
  setCarton: (carton: RpaasRtvWmsBuildCartonObject | null) => void;
  loadPallet: (
    id: string,
    operation_id?: BuildPalletOperation
  ) => Promise<RpaasRtvWmsBuildPalletObject>;
  setPallet: (pallet: RpaasRtvWmsBuildPalletObject | null) => void;
  clearPallet: () => void;
  reset: () => void;
}

export const usePalletBuildStore = create<PalletBuildState>((set) => ({
  cartonId: null,
  carton: null,
  pallet_id: null,
  pallet: null,

  setCartonId: (id) => set({ cartonId: id, carton: null }),
  setCarton: (carton) => set({ carton }),

  loadPallet: async (id, operation_id = PALLET_BUILD_OPERATION_TYPES.CREATE) => {
    const user_id = useAuthStore.getState().user?.id ?? '';
    const result = await apiBuildPallet({
      operation_id,
      user_id,
      license_id: id,
    });
    if (!result) {
      throw new Error('Failed to load pallet');
    }
    if (result.responseState === 'confirmed') {
      set({ pallet_id: id, pallet: result });
    }
    return result;
  },
  setPallet: (pallet) => set({ pallet }),
  clearPallet: () => set({ pallet_id: null, pallet: null }),

  reset: () =>
    set({
      cartonId: null,
      carton: null,
      pallet_id: null,
      pallet: null,
    }),
}));
